export function normalizeCatalogSearch(value) {
  if (!value) return "";
  return String(value)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

function itemHaystack(item, kind) {
  const parts = [
    item.name_en,
    item.name_ar,
    item.sku,
    kind === "service" ? item.service_id : item.package_id,
    item.category,
  ];
  return parts.map(normalizeCatalogSearch).filter(Boolean);
}

export function matchesCatalogItem(item, query, kind = "service") {
  const q = normalizeCatalogSearch(query);
  if (!q) return false;
  const hay = itemHaystack(item, kind);
  return hay.some((h) => h.includes(q) || h.startsWith(q));
}

export function filterServices(services, query, limit = 40) {
  const active = (services || []).filter((s) => s.active !== false);
  const q = normalizeCatalogSearch(query);
  if (!q) return active.slice(0, limit);
  return active.filter((s) => matchesCatalogItem(s, q, "service")).slice(0, limit);
}

export function filterPackages(packages, query, limit = 40) {
  const active = (packages || []).filter((p) => p.active !== false);
  const q = normalizeCatalogSearch(query);
  if (!q) return active.slice(0, limit);
  return active.filter((p) => matchesCatalogItem(p, q, "package")).slice(0, limit);
}
